<script context="module">
	export const TABS = {};
</script>

<script>
    import { setContext, getContext, onMount } from 'svelte';
    import { writable } from 'svelte/store';
    import { getSettingObject, updateSettingObject } from '../../utils'

    export let className;
    export let persistKey = null;

    const tabs = [];
    const selectedTab = writable(null)
    const { defaultKey } = getSettingObject(persistKey)

    setContext(TABS, {
        registerTab: (tab) => {
            tabs.push(tab);
            selectedTab.update(current => current || tab);

        },
        selectTab: (tab) => {
			selectedTab.set(tab);
            if (persistKey) {
                updateSettingObject(persistKey, { defaultKey: tab.key });
            }
        },
        tabs,
        persistKey,
        selectedTab
    });

    const { selectTab } = getContext(TABS);

    onMount(() => {
        // On first mount, maybe activate the last visited tab
        // if persistKey is set
        if (defaultKey && $selectedTab.key !== defaultKey) {
            const tab = tabs.find(tab => tab.key === defaultKey);
            if (tab) {
                selectTab(tab);
            }    
        }
    })

</script>

<div class={className}>
	<slot />
</div>
